import env from "react-dotenv";
import { useQuery, gql } from '@apollo/client';
const axios = require('axios').default;

const API_URL = env.API_URL;

const GET_CATEGORIES = `
  query Categories {
    dealCategories {
      id
      name
      key
    }
  }
`;

const GET_ALL_DEALS = `
  query Deals($perPage: Int, $query: String) {
    dealCategories {
      id
      name
      key
    }
    deals(perPage: $perPage, query: $query) {
        id
        name
        value
        desc
        shortDesc
        terms
        bgColor
        logoColor
        redemption_type
        redemption_url
        redemption_code
        averageSavings
        category
        vendor {
            id
            name
            desc
            category
            rating
            image
            active
        }
    }
  }
`;

const GET_DEAL = `
  query Deal($dealId: ID!) {
    dealCategories {
      id
      name
      key
    }
    deals(perPage: 20) {
        id
        name
        value
        desc
        shortDesc
        terms
        bgColor
        logoColor
        redemption_type
        redemption_url
        redemption_code
        averageSavings
        category
        vendor {
            id
            name
            desc
            category
            rating
            image
            active
        }
    }
    deal(id: $dealId) {
      id
      name
      value
      desc
      shortDesc
      terms
      bgColor
      logoColor
      redemption_type
      redemption_url
      redemption_code
      averageSavings
      category
      similarDeals {
        id
        name
        value
        shortDesc
        terms
        averageSavings
        category
        bgColor
        logoColor
        vendor {
          id
          name
          desc
          category
          rating
          image
          active
        }
      }
      vendor {
          id
          name
          desc
          category
          rating
          image
          active
      }
    }
  }
`;

const GET_CATEGORY_DEALS = `
  query Deals($category: String) {
    deals(category: [$category]) {
        id
        name
        value
        desc
        shortDesc
        terms
        bgColor
        logoColor
        redemption_type
        redemption_url
        redemption_code
        averageSavings
        category
        vendor {
            id
            name
            desc
            category
            rating
            image
            active
        }
    }
  }
`;

const GET_COLLECTION_DEALS = `
  query Deals($collection:[String], $perPage: Int) {
    deals(collection: $collection, perPage: $perPage) {
      id
      name
      value
      desc
      shortDesc
      terms
      bgColor
      logoColor
      collection
      redemption_type
      redemption_url
      redemption_code
      averageSavings
      category
      vendor {
        id
        name
        desc
        category
        rating
        image
        active
      }
    }
  }
`;

const GET_ALL_VENDORS = `
  query Vendors {
    vendors {
      id
      name
      desc
      category
      rating
      image
      active
    }
  }
`;
const DealService = {
  getInitialDeals: async function() {
    let query = GET_ALL_DEALS;
    let variables = {};

    return axios.post(API_URL, {
      query: query,
      variables: variables,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getCategories: async function() {
    let query = GET_CATEGORIES;
    let variables = {};

    return axios.post(API_URL, {
      query: query,
      variables: variables,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getDeal: async function(id) {
    let query = GET_DEAL;
    let variables = {
      dealId: id
    }
    
    return axios.post(API_URL, {
      query: query,
      variables: variables,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getAllDeals: async function(filter=null, perPage=null, searchQuery=null) {
    let query = GET_ALL_DEALS;
    let variables = {};

    if (filter !== null) {
      query = GET_CATEGORY_DEALS;
      variables.category = filter
    }

    if (perPage !== null) {
      variables.perPage = perPage
    }

    if (searchQuery !== null) {
      variables.query = searchQuery;
    }

    return axios.post(API_URL, {
      query: query,
      variables: variables,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getDealCategories: function() {
    return axios.post(API_URL, {
      query: GET_ALL_VENDORS,
      variables: {},
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getDealCollections: function(collection, perPage=10) {
    let variables = {
      collection: [collection],
      perPage: perPage
    };

    return axios.post(API_URL, {
      query: GET_COLLECTION_DEALS,
      variables: variables,
      headers: { 'Content-Type': 'application/json' }
    });
  }
}

export default DealService;
